
  import { Vue, Component } from "vue-property-decorator";
  import PostListItemAdmin from "./PostListItemAdmin.vue";
  import { PostService } from "@/services/admin";
  import { IAdsModel, IPaginationSet } from "@/models";
  import { IUpdateBulkAdModel } from "../../models/viewmodel/IUpdateBulkAdModel";

  @Component({
    name: "PendingAds",
    components: {
      PostListItemAdmin
    }
  })
  export default class PendingAds extends Vue {
    isLoading: boolean = true;
    pageSize: number = 20;
    currentPage: number = 1;
    selectAll: boolean = false;
    action: string = "0";
    result?: IPaginationSet<IAdsModel>;
    currentAd?: IAdsModel = {} as IAdsModel;

    constructor() {
      super();
      this.result = {
        page: 0,
        totalPages: 0,
        pageSize: 0,
        count: 0,
        items: [] as IAdsModel[],
        totalCount: 0
      } as IPaginationSet<IAdsModel>;
    }

    created() {
      setTimeout(() => {
        this.onPageChange(1);
      }, 500);
    }
    onPageChange(page: number) {
      this.currentPage = page;
      this.loadPendingAd();
    }

    async loadPendingAd() {
      this.isLoading = true;
      this.$Progress.start();
      const response = await PostService.GetPendingAuthorization(
        this.currentPage,
        this.pageSize
      );
      this.isLoading = false;
      if (response.status === 200) {
        response.data.items.map(el => {
          el.selected = false;
          el.action = 0;
          el.addNote = false;
          return el;
        });
        this.result = { ...response.data };
      } else {
        this.generateError("Failed when loading data from server");
      }

      this.$Progress.finish();
    }

    onDelete(ad: IAdsModel) {
      this.currentAd = ad;
      this.$bvModal.show("delete-modal-pending");
    }
    onSelectAll() {
      const { items } = this.result;
      items.map(el => {
        el.selected = this.selectAll;
        return el;
      });
      this.result = { ...this.result, items };
    }
    async onBlacklist(ad: IAdsModel) {
      const add = ad.blackListed === 1 ? true : false;
      await PostService.Blacklist(ad.adId, add);
      this.generateSuccess(
        add === true
          ? "Successfully add to blacklist"
          : "Successfully remove from blacklist"
      );

      const { items } = this.result;
      items.map(el => {
        if (el.adId === ad.adId) {
          return ad;
        }
      });
      this.result = { ...this.result, items };
    }
    async onDeleteAll() {
      this.$mainLoader.show();
      const adIds: number[] = [];
      this.result.items.forEach(el => {
        if (el.selected) {
          adIds.push(el.adId);
        }
      });
      await PostService.DeleteMultiple(adIds);
      this.currentPage = 1;
      this.loadPendingAd();
      this.$mainLoader.hide();
    }
    onActionChange() {
      const { items } = this.result;
      items.map(el => {
        el.action = parseInt(this.action, 10);
        return el;
      });
      this.result = { ...this.result, items };
    }
    async onSave(ad: IAdsModel) {
      const actionId = ad.action;
      const pictureId = ad.pictureId || 0;
      const updated: IUpdateBulkAdModel = {
        adId: ad.adId,
        actionId: actionId,
        durationDays: ad.durationDays,
        pictureId: pictureId,
        responseNote: ad.addNote === true ? ad.note : ""
      };
      const arr = new Array<IUpdateBulkAdModel>(updated);
      await PostService.UpdateMultiple(arr);
      this.generateSuccess("Ad has been processed");

      // remove manual ad from list
      const index = this.result.items.findIndex(el => el.adId === ad.adId);
      if (index > -1) {
        this.result.items.splice(index, 1);
        this.result.totalCount -= 1;
      }

      // just sent don't wait
      await PostService.SendEmailPendingAuthorization(arr);
    }
    async onProcessAds() {
      const updateAds: Array<IUpdateBulkAdModel> = [];
      let actionId = parseInt(this.action, 10);
      if (actionId === 0) {
        this.$modal.show("Choose an Action for Selected Ads", "error");
        return false;
      }
      this.result.items.forEach(el => {
        if (el.selected) {
          const pictureId = el.pictureId || 0;
          updateAds.push({
            adId: el.adId,
            actionId: actionId,
            durationDays: el.durationDays,
            pictureId: pictureId,
            responseNote: el.addNote === true ? el.note : ""
          });
        }
      });

      if (updateAds.length === 0) {
        this.generateError("Please select ad to process");
        return true;
      }
      this.$mainLoader.show();
      await PostService.UpdateMultiple(updateAds);
      this.currentPage = 1;
      this.loadPendingAd();
      this.$mainLoader.hide();
      this.generateSuccess(`${updateAds.length} ads has been processed`);

      // just sent don't wait
      await PostService.SendEmailPendingAuthorization(updateAds);
    }
    async handleDelete() {
      await PostService.Delete(this.currentAd.adId);
      this.$bvModal.hide("delete-modal-pending");
      const index = this.result.items.findIndex(
        el => el.adId === this.currentAd.adId
      );
      if (index > -1) {
        this.result.items.splice(index, 1);
        this.result.totalCount -= 1;
      }
    }
    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
    generateSuccess(msg: string) {
      this.$bvToast.toast(`${msg}`, {
        title: "Information",
        variant: "primary",
        autoHideDelay: 5000
      });
    }
  }
